import { Theme } from "../../../components/constants";

export default {
    selectPayerRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "20px",
        marginBottom: "20px",
    },
    selectPayerLabel: {
        fontSize: "1.125rem",
    },
    payerSelectDropDown: {
        width: "300px",
    },
    stateFilingCheckboxDiv: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
    },
    boxSelectRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "center",
    },
    boxSelectDropdownDiv:{
        width: "250px",
    },
    errorFlagLegendInfoContainer: {
        display: "flex",
        flexDirection: "row",
        gap: "30px",
        marginTop: "15px",
    },
    errorFlagLegendInfoDiv: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        alignItems: "center",
    },
    flagCircle: {
        display: "flex",
        width: "15px",
        height: "15px",
        borderRadius: "15px",
    },
    green: {
        background: "#A9CE41",
    },
    red: {
        background: "#C53A3A",
    },
    yellow: {
        background: "#F9C947",
    },
    downloadTextStyle: {
        marginLeft: "8px",
        color: Theme.TEXT_PRIMARY,
        fontWeight: "700",
        cursor: "pointer"
    },
    outerGridBox: {
        margin: "10px 0px",
        border: `1px solid ${Theme.PRIMARY_BORDER}`,
        padding: "10px",
    },
    outerGridBoxFirstRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        borderBottom: `1px solid ${Theme.PRIMARY_BORDER}`,
        paddingBottom: "10px",
    },
    exportButtonsContainer: {
        display: "flex",
        gap: "20px",
    },
    flagFilterColumnStyles: {
        position: "relative",
    },
    flagFilterOptionsDiv: {
        position: "absolute",
        top: "100%",
        left: "0",
        zIndex: "99",
        backgroundColor: "#FFF",
        border: "0.5px solid #B3B3B3",
        borderRadius: "6px",
        boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.05)",
        padding: "10px",
        marginTop: "5px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        width: "350px",
    },
    radioLabel: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    flagFilterOptionsRow: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
    },
    displayNone: {
        display: "none",
    },
    resetButton: {
        textAlign: "center",
    },
    payerRecipientEditLinkStyle: {
        textDecoration: "underline",
        cursor: "pointer",
    },
    errorIconContainerSpan: {
        display: "flex",
        flexDirection: "row",
        gap: "5px",
    },
    errorTooltip: {
        background: Theme.ERROR_BACKGROUND,
    },
    actionButtonsContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "10px",
    },
    actionButton: {
        cursor: "pointer",
    },
    amountsRow: {
        display: "flex",
        gap: "30px",
        justifyContent: "flex-end",
        borderTop: "1px solid #ccc",
        padding: "5px",
    },
    amountText: {
        fontWeight: 700,
    },
    popupBodyStyles: {
        padding: "20px",
        overflow: "visible",
    },
    editContainer: {
        display: "flex",
        flexDirection: "column",
    },
    payerRecipientRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        width: "100%",
    },
    nameContainer: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
    },

    nameDiv: {
        display: "flex",
        flexDirection: "column",
    },

    lightText:{
        lineHeight: "19px",
        color: Theme.TEXT_PRIMARY_BLACK,
    },

    nameText: {
        fontWeight: 700,
        lineHeight: "19px",
        color: "#000000"
    },
    editFieldsContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
    },
    popupBoxValueField: {
        marginTop: "10px",
        display: "flex",
        flexDirection: "row",
        gap: "10px",
    },
    popupChildrenStyle: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "0px 10px 40px 10px",
    },
    reportErrorsDownloadPopupInnerDiv: {
        display: "flex",
        flexDirection: "row",
        gap: "20px",
        alignItems: "center",
    },
    finalSubmitBtnContainer: {
        display: "flex",
        justifyContent: "flex-end",
        margin: "20px"
    },
    errorReportTextContainer: {
        display: "flex",
        flexDirection: "column",
    },
    errorNote: {
        color: Theme.DISABLED_TEXT,
    }
}